import React, { Component } from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import cn from "classnames";

import Seo from "../../../common/helpers/seo";

import AdSense from "../../components/AdSense";
import Icon from "../../icon";
import { Progress, Tick, Page } from "../plan/QuickMeta/styles";

import FormKey from "./FormKey";
import ClassForm from "./ClassForm";
import HomeworkList from "./HomeworkList";

import {
    StyledHomework,
    StyledForm,
    PageContainer,
    Left,
    AdDesktopRight,
    AdDesktopBottom,
    AdMobileBottom,
    AdDesktopMiddle,
    AdMobileTop,
    AdMobileMiddle,
    AttentionScroll,
    AttentionList,
    AttentionCard,
    IconRow,
    AttentionPager,
    AttentionButton,
    AttentionButtonInside,
    getAttentionTranslateX,
} from "./styles";
import messages from "./messages";
import { saveStoreValue, getStoreValue } from "./store";
import { IProps, IState, IDescription } from "./interfaces";
import { AxiosResponse } from "axios";
import { IClass } from "../homeworks/interfaces";
import { ICheckboxEvent, ISelectEvent } from "../../types";
import StudentApplicationAd from "../../components/StudentApplicationAd";

const descriptions: IDescription[] = [
    // {
    //     id: "description",
    //     icon: "user",
    // },
    {
        id: "description1",
        icon: "clock",
    },
    {
        id: "description2",
        icon: "admin",
    },
    {
        id: "description3",
        icon: "give-up",
    },
    {
        id: "description4",
        icon: null,
    },
    {
        id: "description5",
        icon: "refresh",
    },
    {
        id: "description6",
        icon: "join",
    },
];

class Homework extends Component<IProps, IState> {
    state: IState = {
        key: "",
        classes: null,
        selectedClass: undefined,
        homeworks: null,
        saveKey: !!getStoreValue("key"),
        saveClassId: !!getStoreValue("classId"),
        keyValidation: undefined,
        loading: false,
        selectedClassValidation: undefined,
        attentionPage: 0,
    };
    resizeTimer?: ReturnType<typeof setTimeout> = undefined;

    componentDidMount() {
        if (!process.env.WEBPACK) return;
        if (getStoreValue("key")) {
            this.setState({ key: getStoreValue("key")! });
        }
        window.addEventListener("resize", () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(this.resize, 500);
        });
    }

    resize = () => {
        this.forceUpdate();
    }

    changeKey = (e: React.FormEvent<HTMLInputElement>) => this.setState({ key: e.currentTarget.value, keyValidation: undefined });

    submitKey = () => {
        const { key, saveKey } = this.state;
        if (key === "") return this.setState({ keyValidation: "required" });
        this.setState({ loading: true });
        this.props.get(`classes-by-key?key=${key}`, (res: AxiosResponse<{ classes: IClass[] }>) => {
            if (res.data.classes.length === 0) this.setState({ keyValidation: "noResult", loading: false });
            else {
                this.setState(
                    {
                        classes: res.data.classes,
                    },
                    () => {
                        if (saveKey) {
                            saveStoreValue("key", key);
                        }
                        const classId = getStoreValue("classId");
                        if (classId && this.state.classes!.find(({ _id }) => _id === classId)) {
                            this.setState({ selectedClass: classId, loading: false });
                        } else {
                            this.setState({ loading: false });
                        }
                    }
                );
            }
        }, () => {
            this.setState({
                loading: false,
            })
        });
    };

    changeClass = (e: ISelectEvent) => this.setState({ selectedClass: e.target.value, selectedClassValidation: undefined });

    submitClass = () => {
        const { selectedClass, saveClassId } = this.state;
        if (!selectedClass) return this.setState({ selectedClassValidation: "required" });
        this.setState({ loading: true });
        this.props.get(`homeworks-by-class?classId=${selectedClass}`, res => {
            if (res.data.homeworks.length === 0) {
                this.setState({ selectedClassValidation: "noHomeworkOrExpired" });
            } else {
                if (saveClassId) {
                    saveStoreValue("classId", selectedClass);
                }
                this.setState({ homeworks: res.data.homeworks });
            }
            this.setState({ loading: false });
        }, () => {
            this.setState({ loading: false });
        });
    };

    cancelToKey = () => {
        this.setState({
            classes: null,
            selectedClass: undefined,
            selectedClassValidation: undefined,
        });
    };
    cancelToClasses = () => {
        this.setState({
            homeworks: null,
        });
    };
    handleChangeSaveKey = ({ target: { checked: saveKey } }: ICheckboxEvent) => {
        if (!saveKey) {
            saveStoreValue("key", "");
            saveStoreValue("classId", "");
        }
        this.setState({ saveKey, saveClassId: false });
    };
    handleChangeSaveClassId = ({ target: { checked: saveClassId } }: ICheckboxEvent) => {
        if (!saveClassId) {
            saveStoreValue("classId", "");
        }
        this.setState({ saveClassId });
    };
    render() {
        const {
            key,
            keyValidation,
            classes,
            selectedClass,
            selectedClassValidation,
            homeworks,
            loading,
            saveKey,
            saveClassId,
            attentionPage,
        } = this.state;
        const {
            intl: { formatMessage },
            theme,
        } = this.props;
        const formKeyProps = {
            loading,
            keyValidation,
            teacherKey: key,
            saveKey,
            changeKey: this.changeKey,
            handleChangeSaveKey: this.handleChangeSaveKey,
            submitKey: this.submitKey,
        };
        const formClassProps = {
            selectedClass,
            selectedClassValidation,
            saveClassId,
            classes: classes!,
            loading,
            onChange: this.changeClass,
            handleChangeSaveClassId: this.handleChangeSaveClassId,
            submitClass: this.submitClass,
            cancelToKey: this.cancelToKey,
        };
        const listHomeworkProps = {
            homeworks: homeworks!,
            cancelToClasses: this.cancelToClasses,
        };
        return (
            <StyledHomework marginTop={50}>
                <Seo title={formatMessage(messages.homework)} />
                <h1>
                    <FormattedMessage {...messages.homework} />
                </h1>
                <AdMobileTop>
                    {/* <AdSense height={100} slot="Homework_Top-Mobile" /> */}
                    <StudentApplicationAd />
                </AdMobileTop>
                <PageContainer>
                    <Left>
                        <FormattedHTMLMessage {...messages.description} />
                        {/* <AdDesktopMiddle>
                            <AdSense height={90} slot="Homework_Middle-Desktop" />
                        </AdDesktopMiddle> */}
                        {/* <AdMobileMiddle>
                            <AdSense height={100} slot="Homework_Middle-Mobile" />
                        </AdMobileMiddle> */}
                        <Progress>
                            <Page active={classes === null} completed={Array.isArray(classes)}>
                                <FormattedMessage {...messages.progressKey} />
                                {Array.isArray(classes) && <Tick />}
                            </Page>
                            <Page
                                active={Array.isArray(classes) && !Array.isArray(homeworks)}
                                completed={Array.isArray(homeworks)}
                            >
                                <FormattedMessage {...messages.progressClass} />
                                {Array.isArray(homeworks) && <Tick />}
                            </Page>
                            <Page active={Array.isArray(homeworks)} completed={false}>
                                <FormattedMessage {...messages.progressHomework} />
                                {false && <Tick />}
                            </Page>
                        </Progress>
                        <StyledForm>
                            {classes === null && <FormKey {...formKeyProps} />}
                            {Array.isArray(classes) && homeworks === null && <ClassForm {...formClassProps} />}
                            {Array.isArray(homeworks) && <HomeworkList {...listHomeworkProps} />}
                        </StyledForm>
                        <h3>{formatMessage(messages.attention)}</h3>
                        <AttentionScroll>
                            <AttentionList style={{ transform: `translateX(${getAttentionTranslateX(attentionPage, theme)}px)` }}>
                                {descriptions.map(({ id, icon }, index) => (
                                    <AttentionCard key={index}>
                                        {icon && <IconRow>
                                            <Icon i={icon} />
                                        </IconRow>}
                                        <FormattedHTMLMessage {...messages[id as "description1"]} />
                                    </AttentionCard>
                                ))}
                            </AttentionList>
                        </AttentionScroll>
                        <AttentionPager>
                            {descriptions.map(({ id }, index) => (
                                <AttentionButton
                                    key={id}
                                    className={cn(attentionPage === index && "Active", index + 1 === descriptions.length && "Last")}
                                    onClick={() => {
                                        this.setState({ attentionPage: index });
                                    }}
                                >
                                    <AttentionButtonInside />
                                </AttentionButton>
                            ))}
                        </AttentionPager>
                    </Left>
                    <AdDesktopRight>
                        {/* <AdSense width={300} height="100%" slot="Homework_Aside-Desktop" /> */}
                        {/* <StudentApplicationAd /> */}
                    </AdDesktopRight>
                </PageContainer>
                {/* <AdDesktopBottom>
                    <AdSense height={150} slot="Homework_Bottom-Desktop" />
                </AdDesktopBottom>
                <AdMobileBottom>
                    <AdSense height={320} slot="Homework_Bottom-Mobile" />
                </AdMobileBottom> */}
            </StyledHomework>
        );
    }
}

export default Homework;
